<template>
  <a-layout>
    <a-layout-sider
      id="leftSider"
      v-model:collapsed="collapsed"
      theme="light"
      :trigger="null"
      collapsible
    >
      <div class="logo d-flex justify-content-center align-items-center">
        <div v-if="collapsed">
          <img src="../../assets/logo.png" class="mx-auto d-block" alt="logo" />
        </div>
        <div v-else class="d-flex justify-content-center">
          <img src="../../assets/logo.png" alt="logo" />
          <h4 class="ms-2">Cloud<span>Ext</span></h4>
        </div>
      </div>
      <!-- Menus -->
      <a-menu
        class="menu-list"
        v-model="selectedKeys"
        theme="light"
        mode="inline"
      >
        <div v-for="menu in menulist" :key="menu">
          <a-menu-item
            v-if="!menu.subMenuTitle"
            :key="menu.keyIndex"
            :class="
              this.$route.name == menu.routerName
                ? 'ant-menu-item-selected'
                : ''
            "
          >
            <router-link :to="menu.link">
              <vue-feather :type="menu.icon" />
              <span class="title">{{ menu.name }}</span>
            </router-link>
          </a-menu-item>
          <div v-if="menu.subMenuTitle">
            <a-sub-menu :key="menu.submenuKey">
              <template #icon>
                <vue-feather :type="menu.subMenIcon" />
              </template>
              <template #title>{{ menu.subMenuTitle }}</template>
              <a-menu-item
                :key="submenu.keyIndex"
                v-for="submenu in menu.subMenuList"
                :class="
                  this.$route.name == submenu.routerName
                    ? 'ant-menu-item-selected'
                    : ''
                "
              >
                <router-link :to="submenu.link">
                  <vue-feather :type="submenu.icon" />
                  <span class="title">{{ submenu.name }}</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </div>
        </div>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header
        id="header"
        theme="light"
        class="d-flex justify-content-between align-items-center px-3 bg-light"
      >
        <div class="d-flex align-items-center">
          <vue-feather
            type="menu"
            class="trigger text-primary me-2"
            @click="collapsed = !collapsed"
          />
          <div class="text-muted">
            <span class="fw-semibold">Local Time:</span>
            <span class="ms-1">{{ localTime }}</span>
          </div>
          <a-tooltip placement="bottom">
            <template #title>
              <span>Account Name : </span>
              <label>{{ account.name }}</label>
              <br />
              <span>E-Mail : </span>
              <label>
                {{ account?.email ?? "-" }}
              </label>
              <br />
              <span>Mobile : </span>
              <label>
                {{ account?.phone_number ?? "-" }}
              </label>
              <br />
              <span>Timezone : </span>
              <label>
                {{ account?.timezone ?? "America/New_York" }}
              </label>
              <br />
              <span>Website : </span>
              <label>
                <div>
                  <span class="fw-semibold">
                    {{ account?.website_url }}
                  </span>
                  <vue-feather
                    type="external-link"
                    class="pointer text-warning"
                    v-if="!['', null, undefined].includes(account?.website_url)"
                    @click="openView(account.website_url)"
                  />
                </div>
              </label>
              <br />
            </template>
            <vue-feather type="info" class="trigger text-muted ms-1" />
          </a-tooltip>
        </div>
        <div>
          <!-- <vue-feather class="pointer m-0" type="sun" size="0.9rem" /> -->
          <a-badge
            size="small"
            class="mx-3"
            v-if="user?.user && !user.user.is_superuser"
            :count="activities.length"
            :overflow-count="999"
            :title="`${activities.length} Unchecked Alerts`"
            @click="showAlert()"
          >
            <vue-feather
              v-if="user?.user && !user.user.is_superuser"
              class="pointer m-0"
              type="bell"
              size="0.9rem"
            />
          </a-badge>
          <a-dropdown
            v-if="user && !user.user.is_superuser"
            :trigger="['click']"
            @visibleChange="haschangeSelect = !haschangeSelect"
          >
            <a class="ant-dropdown-link text-decoration-none">
              {{ currenntUserName }}
              <vue-feather
                :type="haschangeSelect ? 'chevron-up' : 'chevron-down'"
                class="trigger text-primary"
              />
            </a>
            <template #overlay>
              <a-menu variant="outline-primary">
                <template v-for="account in crmAccounts" :key="account.id">
                  <a-menu-item
                    @click="crmAccountChange(account.id)"
                    :disabled="account.id === this.currentUserAccount"
                    class="d-flex align-items-center"
                  >
                    <vue-feather
                      size="0.9rem"
                      type="settings"
                      animation="spin"
                      animation-speed="slow"
                      class="me-2 text-success"
                      v-if="account.id === this.currentUserAccount"
                    />
                    <span>
                      {{ account.name }}
                    </span>
                  </a-menu-item>
                </template>
              </a-menu>
            </template>
          </a-dropdown>
          <a-dropdown
            :trigger="['click']"
            @visibleChange="isDdOpen = !isDdOpen"
          >
            <a class="ant-dropdown-link text-decoration-none text-capitalize">
              {{ user?.user?.first_name ? user?.user?.first_name : "" }}
              {{ user?.user?.last_name ? user?.user?.last_name : "" }}
              <vue-feather
                :type="isDdOpen ? 'chevron-up' : 'chevron-down'"
                class="trigger text-primary"
              />
            </a>
            <template #overlay>
              <a-menu>
                <span v-if="user && !user.user.is_superuser">
                  <!-- <a-menu-item @click="isDdOpen = false">
                    <a href="javascript:;" class="text-decoration-none">
                      <vue-feather type="log-out" class="trigger" />
                      Exit Business
                    </a>
                  </a-menu-item> -->
                  <a-menu-item>
                    <div class="d-flex align-items-center">
                      <vue-feather
                        type="alert-circle"
                        class="trigger text-success"
                      />
                      <span> v03.26.0609 </span>
                      <!-- v(03).(YY).(MMDD) -->
                    </div>
                  </a-menu-item>
                  <a-menu-item @click="isDdOpen = false">
                    <router-link
                      to="/account/edit"
                      class="text-decoration-none"
                    >
                      <vue-feather type="lock" class="trigger" />
                      Account
                    </router-link>
                  </a-menu-item>
                  <!-- <a-menu-item @click="isDdOpen = false">
                    <a href="javascript:;" class="text-decoration-none">
                      <vue-feather type="star" class="trigger" />
                      Subscripation
                    </a>
                  </a-menu-item> -->
                  <!-- <a-menu-item @click="isDdOpen = false">
                    <router-link to="/billing" class="text-decoration-none">
                      <vue-feather
                        type="credit-card"
                        class="trigger"
                       />
                      Billing
                    </router-link>
                  </a-menu-item> -->
                </span>
                <a-menu-item class="text-danger" @click="isDdOpen = false">
                  <a
                    href="javascript:;"
                    @click="logOut()"
                    class="text-decoration-none"
                  >
                    <vue-feather type="power" class="trigger" />
                    Logout
                  </a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>
      <slot />
    </a-layout>
  </a-layout>

  <a-modal
    width="60%"
    v-model:visible="visible"
    title="Opportunity Notifications"
  >
    <template #footer>
      <a-button type="primary" size="small" @click="setLoc()">
        Understood
      </a-button>
    </template>
    <a-card :loading="isDataLoading" v-if="isDataLoading" :bordered="false">
      <div></div>
    </a-card>
    <a-row
      :gutter="[16, 0]"
      v-else-if="!isDataLoading && activities.length !== 0"
    >
      <a-col :xl="24" :lg="24" :md="24" :sm="24" :span="24">
        <a-collapse
          class="rounded m-0"
          v-for="(act, index) in activities"
          :key="index"
        >
          <a-collapse-panel class="my-1">
            <template #header>
              <a-tooltip>
                <template #title>
                  <span class="text-capitalize">
                    {{ act?.activity_type }} By {{ act.created_by || "user" }}
                  </span>
                </template>
                <div class="text-primary d-flex align-items-center m-s0">
                  <span
                    class="fw-bold me-1 text-capitalize"
                    v-if="act?.activity_type === 'call'"
                  >
                    Logged
                  </span>
                  <span
                    class="fw-bold m-0 d-flex align-items-center"
                    v-if="act?.activity_type === 'task'"
                  >
                    <vue-feather
                      type="check-circle"
                      :class="
                        act?.is_task_completed ? 'text-success' : 'text-danger'
                      "
                    />
                  </span>
                  <span
                    class="fw-bold me-1 text-capitalize"
                    :class="
                      act?.activity_type === 'call'
                        ? 'text-success'
                        : act?.activity_type === 'task'
                        ? 'text-warning'
                        : act?.activity_type === 'note'
                        ? 'text-danger'
                        : ''
                    "
                  >
                    {{ act?.activity_type || "Logged Call" }}
                  </span>
                  <span class=""> by {{ act?.created_by || "user" }} </span>
                </div>
              </a-tooltip>
            </template>
            <template #extra>
              <div class="d-flex align-items-center">
                <small class="text-secondary mx-2">
                  Opportunity
                  <a-tooltip>
                    <template #title>
                      #{{ act?.lead_opportunity?.opportunity_number }}
                      <br />
                      Name : {{ act?.lead_opportunity?.first_name ?? "" }}
                      {{ act?.lead_opportunity?.last_name ?? "" }}
                      <br />
                      Mobile : {{ act?.lead_opportunity?.mobile ?? "-" }}
                      <br />
                      Property :
                      {{ act?.lead_opportunity?.property_name ?? "-" }}
                    </template>
                    <span class="text-danger">
                      #{{ act?.lead_opportunity?.opportunity_number }}
                    </span>
                  </a-tooltip>
                </small>
                <small class="mt-0">
                  {{ act?.created_at ? datify(act.created_at) : "-" }}
                </small>
              </div>
            </template>
            <div class="mb-3">
              {{ act?.description || "-" }}
              <a-tooltip>
                <template #header>View Opportunity</template>
                <router-link
                  v-if="act?.lead_opportunity?.id"
                  :to="`/opportunities/opportunity-log/${act.lead_opportunity.id}`"
                >
                  <vue-feather
                    type="eye"
                    class="text-primary float-end"
                    @click="visible = false"
                  />
                </router-link>
              </a-tooltip>
            </div>
            <div class="mb-3" v-if="act.activity_type === 'task'">
              <span v-if="act?.activity_type === 'task'">
                <div class="d-flex align-items-center">
                  <vue-feather
                    type="check-circle"
                    :class="
                      act?.is_task_completed ? 'text-success' : 'text-danger'
                    "
                  />
                  <span
                    :class="
                      act?.is_task_completed
                        ? 'text-decoration-line-through'
                        : ''
                    "
                    class="text-secondary"
                  >
                    {{ act?.task_name || "-" }}
                  </span>
                </div>
              </span>
            </div>

            <hr
              v-if="act?.description && act.activity_type !== 'note'"
              class="fw-bold m-0 my-3 text-muted dashed"
            />

            <a-row :gutter="[16, 0]" v-if="act.activity_type === 'call'">
              <a-col :xl="4" :lg="4" :md="4" :sm="4" :span="24">
                <div class="mb-3">
                  <label for="contact">Contacted</label>
                  <a-typography-text
                    id="contact"
                    size="small"
                    class="d-block w-100 text-capitalize"
                  >
                    {{
                      `${act?.lead_opportunity?.first_name ?? "-"} ${
                        act?.lead_opportunity?.last_name ?? ""
                      }`
                    }}
                  </a-typography-text>
                </div>
              </a-col>
              <a-col :xl="4" :lg="4" :md="4" :sm="4" :span="24">
                <div class="mb-3">
                  <label for="call_outcome">Outcome</label>
                  <a-select
                    disabled
                    size="small"
                    id="call_outcome"
                    :bordered="false"
                    class="w-100 text-capitalize"
                    v-model:value="act.call_outcome"
                    :options="outcomeOpt"
                  />
                </div>
              </a-col>
              <a-col :xl="4" :lg="4" :md="4" :sm="4" :span="24">
                <div class="mb-3">
                  <label for="call_direction">Direction</label>
                  <a-select
                    disabled
                    size="small"
                    :bordered="false"
                    id="call_direction"
                    class="w-100 text-capitalize"
                    v-model:value="act.call_direction"
                    :options="directOpt"
                  />
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="[16, 0]" v-if="act.activity_type === 'task'">
              <a-col :xl="6" :lg="6" :md="6" :sm="6" :span="24">
                <div class="mb-3">
                  <label for="task_type">Task Type</label>
                  <a-select
                    disabled
                    size="small"
                    id="task_type"
                    :bordered="false"
                    class="w-100 text-capitalize"
                    v-model:value="act.task_type"
                    :options="taskOpt"
                  />
                </div>
              </a-col>
              <a-col :xl="6" :lg="6" :md="6" :sm="6" :span="24">
                <div class="mb-3">
                  <label for="assign_by">Assign to</label>
                  <a-select
                    disabled
                    size="small"
                    :bordered="false"
                    id="assign_by"
                    class="w-100 text-capitalize"
                    v-model:value="act.assign_by"
                    :options="allUsers"
                  />
                </div>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-card v-else :bordered="false">
      <label class="d-flex align-items-center justify-content-center">
        Cheers ! There is no pending task right now !!
      </label>
      <Vue3Lottie :animationData="successData" :height="250" class="" />
    </a-card>
  </a-modal>
</template>
<script>
import { authComputed, authMethods } from "@/helpers/Store/helpers.js";
import opportunityService from "@/helpers/API/opportunity.service";
import AuthService from "@/helpers/API/Auth/auth.service.js";
import successData from "@/assets/animations/success.json";
import UserService from "@/helpers/API/user.service.js";
import { accountChange } from "@/helpers/GlobalFunc.js";
import errorHandler from "@/helpers/ErrorHandler.js";
import { menulist } from "@/helpers/Menu.js";
import { message } from "ant-design-vue";
import { Vue3Lottie } from "vue3-lottie";
import dayjs from "@/helpers/dayjsConfig.js";

export default {
  name: "App",
  data() {
    return {
      selectedKeys: ["1"],
      collapsed: true,
      menulist: menulist,
      isDdOpen: false,
      haschangeSelect: false,
      crmAccounts: [],
      currentUserAccount: "",
      currenntUserName: "",
      visible: false,
      isDataLoading: false,
      activities: [],
      successData,
      currentTime: dayjs(),
      timer: null,
      iconUrl: "",
    };
  },
  components: { Vue3Lottie },
  computed: {
    ...authComputed,
    localTime() {
      return this.currentTime
        .tz(this.account?.timezone ?? "America/New_York")
        .format("MMM DD, YYYY HH:mm:ss A");
    },
  },
  mounted() {
    if (this.user.user.is_superuser == false) {
      this.currentUserAccount = this.account.id;
      this.crmAccounts = this.user.user.crm_accounts;
      for (let index = 0; index < this.crmAccounts.length; index++) {
        const element = this.crmAccounts[index];
        if (element.id == this.currentUserAccount) {
          this.currenntUserName = element.name;
        }
      }
    }
    // Managing layout between super admin and normal user
    if (this.user.user.is_superuser == true) {
      const hySuper = this.menulist.filter((val) => {
        if (val.is_super == true) {
          return val;
        }
      });
      this.menulist = hySuper;
    } else {
      let perms = this.user.user.crm_access_settings;
      let metaPerm = {};
      metaPerm.is_lead = perms.lead.is_view;
      metaPerm.is_marketing = perms.marketing.is_view;
      metaPerm.is_proposal = perms.proposal.is_view;
      metaPerm.is_invoice = perms.invoice.is_view;
      metaPerm.is_inventory = perms.inventory.is_view;
      metaPerm.is_shipping = perms.shipping.is_view;
      metaPerm.is_installation = perms.installation.is_view;
      metaPerm.is_subscription = perms.subscription.is_view;
      metaPerm.is_porting = perms.porting.is_view;
      metaPerm.is_ticket = perms.ticket.is_view;
      metaPerm.is_settings = perms.settings.is_view;
      let permissions = { ...metaPerm, isAll: true };
      const hySuper = this.menulist.filter((val) => {
        if (val.is_super == false) {
          return val;
        }
      });
      const filteredMenu = hySuper.filter((menuItem) => {
        // Check if isShow is present in the permissions object and is true
        if (menuItem.isShow && permissions[menuItem.isShow]) {
          return true;
        }
        // If isShow is not present or is false in permissions, do not include in the filtered menu
        return false;
      });
      this.menulist = filteredMenu;
    }
    if (!localStorage.notShowed) {
      this.showAlert();
    } else {
      this.getAlertList();
    }

    this.timer = setInterval(() => {
      this.currentTime = dayjs(); // Update current time
    }, 1000);

    this.iconUrl = this.account?.favicon_icon;
    if (!["", null, undefined].includes(this.iconUrl)) {
      this.setFavicon(this.iconUrl);
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    ...authMethods,
    logOut() {
      AuthService.logout();
      this.$router.push("/login");
    },
    setFavicon(iconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = iconUrl;
    },
    async crmAccountChange(id) {
      this.haschangeSelect = false;
      if (id != this.currentUserAccount) {
        await UserService.updateProfile({ user_crm_account: id })
          .then(async () => {
            let data = accountChange(this.$route.fullPath);
            await this.setAccount(id)
              .then(async () => {
                if (data.length != 0) {
                  await this.$router.push(data[0].path);
                  await this.setNewAccountData();
                  this.$router.go();
                  return;
                }
                await this.setNewAccountData();
                this.$router.go();
              })
              .catch((error) => {
                errorHandler(error);
              });
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    async setNewAccountData() {
      await this.setDepartments();
    },
    // Method is used to get alert list
    async getAlertList() {
      this.activities = [];
      this.isDataLoading = true;
      await opportunityService
        .getOpportunityLogs(
          `?assign_by=${this.user.user.id}&is_task_completed=False&activity_type=task`,
        )
        .then((res) => {
          this.isDataLoading = false;
          if (res.status == false) {
            return message.warning(res.message);
          }
          let someArray = [];
          res.results.map((item) => {
            someArray.push({ ...item, assign_by: item?.assign_by?.id ?? "" });
          });
          this.activities = someArray;
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
        });
    },
    showAlert() {
      if (this.user && this.user.user.is_superuser) {
        return;
      }
      this.visible = !this.visible;
      this.getAlertList();
    },
    setLoc() {
      localStorage.setItem("notShowed", true);
      this.visible = !this.visible;
    },
    datify(date) {
      return dayjs(date)
        .tz(this.account?.timezone ?? "America/New_York")
        .format("MMM DD, YYYY HH:mm A");
    },
    openView(data) {
      window.open(data, "_blank");
    },
  },
};
</script>
